import React from 'react';
import BaseCard from '../../../../Dashboard/components/BaseCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons';
import { Box, LinearProgress, Typography } from '@mui/material';
import {
  customError,
  dimGrey,
  inactive,
  warningYellow,
} from '../../../../../mainTheme';

interface IssuesCardProps {
  data: {
    high: number;
    low: number;
  };
  isSelected?: boolean;
  onClick?: () => void;
}

const IssuesCard: React.FC<IssuesCardProps> = ({
  data,
  isSelected,
  onClick,
}) => {
  return (
    <BaseCard
      title="Issues"
      isSelected={isSelected}
      onClick={onClick}
      icon={<FontAwesomeIcon icon={faTriangleExclamation} color={dimGrey} />}
      totalCount={`${data.high + data.low} total`}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          mt: '16px',
        }}
      >
        <Box display="flex" flexDirection="column" gap="5.3px">
          <LinearProgress
            variant="determinate"
            value={
              data.high + data.low === 0
                ? 0
                : (data.high / (data.high + data.low)) * 100
            }
            sx={{
              height: '6px',
              bgcolor: inactive,
              borderRadius: '7.5px',
              '& .MuiLinearProgress-bar': {
                backgroundColor: customError,
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px',
              }}
            >
              High priority
            </Typography>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: '16px',
              }}
            >
              {data.high}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap="5.3px">
          <LinearProgress
            variant="determinate"
            value={
              data.high + data.low === 0
                ? 0
                : (data.low / (data.high + data.low)) * 100
            }
            sx={{
              height: '6px',
              bgcolor: inactive,
              borderRadius: '7.5px',
              '& .MuiLinearProgress-bar': {
                backgroundColor: warningYellow,
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '16px',
              }}
            >
              Low priority
            </Typography>
            <Typography
              sx={{
                color: dimGrey,
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: '16px',
              }}
            >
              {data.low}
            </Typography>
          </Box>
        </Box>
      </Box>
    </BaseCard>
  );
};

export default IssuesCard;
